var _NotificationsPortal;

import React from 'react';
import { StoreContext } from 'storeon/react';
import { NotificationsStore } from './NotificationsStore';
import { NotificationsPortal } from './NotificationsPortal';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Notification/NotificationsProvider');
export var NotificationsProvider = function NotificationsProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StoreContext.Provider, {
    value: NotificationsStore
  }, children, _NotificationsPortal || (_NotificationsPortal = /*#__PURE__*/React.createElement(NotificationsPortal, null)));
};